import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";

// Options
//  OPTION

// action types
export const ADD_ATTRIBUTE_OPTION = "addAttributeOption";
export const GET_ATTRIBUTE_OPTIONS = "getAttributeOptions";
export const GET_ATTRIBUTE_OPTION = "getAttributeOption";
export const UPDATE_ATTRIBUTE_OPTION = "updateAttributeOption";
export const DELETE_ATTRIBUTE_OPTION = "deleteAttributeOption";

// mutation types
export const SET_ATTRIBUTE_OPTIONS_ERROR = "setErrorsAttributeOptions";
export const SET_ATTRIBUTE_OPTIONS = "setAttributeOptions";
export const SET_ATTRIBUTE_OPTION = "setAttributeOption";
export const SET_ATTRIBUTE_OPTION_LOAD = "setAttributeOptionLoad";

const state = {
    errors: {},
    attributeOptions: {},
    load: true,
    attributeOption: {},
};

const getters = {
    gettersAttributeOptions(state) {
        return state.attributeOptions;
    },
    gettersAttributeOption(state) {
        return state.attributeOption;
    },
    errorsAttributeOption(){
        return state.errors;
    },
    getAttributeOptionLoad(){
        return state.load;
    },
};

const actions = {

    [ADD_ATTRIBUTE_OPTION](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_ATTRIBUTE_OPTIONS_ERROR, {});
            ApiService.post("/attribute-option/store", data)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                    if (response.status === 422){
                        context.commit(SET_ATTRIBUTE_OPTIONS_ERROR, response.data.errors);
                    }
                });
        });
    },

    [GET_ATTRIBUTE_OPTIONS](context, attribute) {
        return new Promise((resolve, reject) => {
            context.commit(SET_ATTRIBUTE_OPTION_LOAD, true);
            ApiService.get("/attribute-options", attribute)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_ATTRIBUTE_OPTIONS, data);
                    context.commit(SET_ATTRIBUTE_OPTION_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_ATTRIBUTE_OPTIONS_ERROR, response.data.errors);
                    context.commit(SET_ATTRIBUTE_OPTION_LOAD, false);
                });
        });
    },

    [GET_ATTRIBUTE_OPTION](context, id) {
        context.commit(SET_ATTRIBUTE_OPTION_LOAD, true);
        ApiService.get("/attribute-option", id)
            .then(({ data }) => {
                context.commit(SET_ATTRIBUTE_OPTION, data);
                context.commit(SET_ATTRIBUTE_OPTION_LOAD, false);
            })
            .catch(({ response }) => {
                context.commit(SET_ATTRIBUTE_OPTIONS_ERROR, response.data.errors);
                context.commit(SET_ATTRIBUTE_OPTION_LOAD, false);
            });
    },

    [UPDATE_ATTRIBUTE_OPTION](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("/attribute-option/update", data.id, data)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ATTRIBUTE_OPTIONS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_ATTRIBUTE_OPTIONS_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },

    [DELETE_ATTRIBUTE_OPTION](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/attribute-option/delete", data.attribute + '/' + data.option)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ATTRIBUTE_OPTIONS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },


}


const mutations = {

    [SET_ATTRIBUTE_OPTIONS_ERROR](state, error) {
        state.errors = error;
    },

    [SET_ATTRIBUTE_OPTIONS](state, data) {
        state.attributeOptions = data.options;

    },

    [SET_ATTRIBUTE_OPTION](state, data) {
        state.attributeOption = data.option;
    },

    [SET_ATTRIBUTE_OPTION_LOAD](state, load) {
        state.load = load;
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};

